import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
  ReverseMoney,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface SetClaimSolutionCommandArgs {
  claimId: string;
  solutionTypeId: string;
  solutionPrice: ReverseMoney;
}

export const setClaimSolutionRequest = ({
  claimId,
  solutionTypeId,
  solutionPrice,
}: SetClaimSolutionCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/solution`,
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: { solutionTypeId, solutionPrice },
  },
});

export const setClaimSolutionCommand = async (
  args: SetClaimSolutionCommandArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      setClaimSolutionRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
